import React from 'react';
import { useChatTheme, useThemeStyles } from '../../contexts/ChatThemeContext';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';

interface ChatHeaderProps {
  userName: string;
  userInitials: string;
  isOnline?: boolean;
  onThemeToggle?: () => void;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({ 
  userName, 
  userInitials, 
  isOnline = true,
  onThemeToggle 
}) => {
  const { theme, themeName, toggleTheme } = useChatTheme();
  const styles = useThemeStyles();

  const handleThemeToggle = () => {
    toggleTheme();
    onThemeToggle?.();
  };

  return (
    <div style={styles.header} className="chat-header">
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1 }}>
        <div style={styles.avatar}>
          {userInitials}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ 
            fontWeight: 600, 
            fontSize: theme.typography.headerFontSize,
            color: theme.colors.primaryText,
            marginBottom: '4px'
          }}>
            {userName}
          </div>
          {isOnline && (
            <div style={{
              fontSize: '13px',
              color: theme.colors.secondaryText,
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}>
              <span style={styles.statusDot} />
              Online
            </div>
          )}
        </div>
        
        {/* Theme Toggle Button */}
        <button
          onClick={handleThemeToggle}
          style={{
            background: 'none',
            border: 'none',
            padding: '8px',
            cursor: 'pointer',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: theme.colors.mutedText,
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = themeName === 'dark' 
              ? 'rgba(255, 255, 255, 0.1)' 
              : 'rgba(0, 0, 0, 0.05)';
            e.currentTarget.style.color = theme.colors.accent;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'none';
            e.currentTarget.style.color = theme.colors.mutedText;
          }}
          title={`Switch to ${themeName === 'light' ? 'dark' : 'light'} mode`}
        >
          {themeName === 'light' ? (
            <MoonIcon className="h-5 w-5" />
          ) : (
            <SunIcon className="h-5 w-5" />
          )}
        </button>
      </div>
    </div>
  );
};